import React, { useState, useContext, useRef, useEffect, useReducer } from 'react';
import { FormattedMessage, useIntl, IntlContext } from 'react-intl';
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import { API } from 'aws-amplify';
import Spinner from '../../../components/Spinner';
import { currentLongLang } from '../../../components/components/utils';
import AppContext from '../../../components/AppContext';
import { SelectFieldWithLabel, TextFieldWithLabel, CheckboxWithLabel, TextFieldWithLabelAndOnKeyDownHandler } from './../../../components/FormFields';
import MagnifiquePopup from '../../../components/MagnifiquePopup.js';
import { constants } from '../../../constants'

function AddClientFormik(props) {
	const [, forceUpdate] = useReducer(x => x + 1, 0);
	const appContext = useContext(AppContext);
	const { messages } = useContext(IntlContext);
	const InnerFormikRef = useRef();
	//note: this labels variable has to contain labels for each field name that has validation against.  The key here has to match the "name" property of the field.
	const labels = {
		"http.networkError"                              : useIntl().formatMessage({id:"http.networkError"}, {p: (chunks) => <p>{chunks}</p>, a: (chunks) => <a href={"https://www.cbsa-asfc.gc.ca/contact/bis-sif-"+(document.documentElement.lang === "fr" ? "fra" : "eng")+".html"} className="App-link" target="_blank" rel="noreferrer">{chunks}</a>})//
		, "sima.representative.businessNumber.counsel"   : useIntl().formatMessage({id:"sima.representative.businessNumber.counsel"}, {abbr: (chunks) => <abbr title="A 15-character alphanumeric identifier assigned by the Canada Revenue Agency to identify a business, made up of the 9 digit business number appended by a 6 digit alpha-numerical number used to uniquely identify the business’s import/export accounts (e.g., 123456789RM0001)">{chunks}</abbr>, a: (chunks) => <a href="#fn1">{chunks}</a>, sup: (chunks) => <sup id="fn1-rf">{chunks}</sup>})
		, "sima.account.accountInfo.clientCertify.radio" : useIntl().formatMessage({id:"sima.account.accountInfo.clientCertify.radio"}, {a1: (chunks) => <a target="_blank" href={"https://www.cbsa-asfc.gc.ca/sima-lmsi/forms-formulaires/letter-of-authorization-"+(document.documentElement.lang === "fr" ? "fra" : "eng")+".html"}>{chunks}</a>, i: (chunks) => <i>{chunks}</i>, strong: (chunks) => <strong>{chunks}</strong>})
	}

	const [businessData, setBusinessData] = useState({});
	const [clientRolesList, setClientRolesList] = useState([]);
	const {roles} = appContext.codeTables;
	const [isValidBN, setIsValidBN] = useState(true);

	let clientRoles = []
		
	useEffect(() => {
		roles.forEach(a => {
			if (a.value !== constants.roles["Counsel"]) {
				clientRoles.push(a)
			}
		})
		setClientRolesList(clientRoles)
	}, [roles]);
	
	const [showSpinner, setShowSpinner] = useState(false);
	
	const handleBusinessSearchClick = (ace_businessnumber, setFieldValue) => {
		setShowSpinner(true);
		let apiURL = "getBusinessAttributes";
		let apiPostObj = {
			body: {
				"ace_businessnumber": ace_businessnumber
			}
		}
		
		API.post("backend-api", apiURL, apiPostObj).then(function(response){
			
			let responseData = response;
			responseData.companyCountry = appContext?.codeTableLookup?.countries?.[response["companyCountryCode"]];   // converted to GUID from preliminaryData
			responseData.companyProvince = response.companyProvinceCode; //TODO - convert this to GUID from preliminaryData, when we start getting the MDM codes from mid-tier
			
			setFieldValue("companyLegalName", responseData.companyLegalName);
			setBusinessData({ace_businessnumber: ace_businessnumber, ...responseData});
			
		}).catch(function(error){
			if (window.env.environment !== "prod") {
				console.log({error})
			}
			if (window.env.environment !== "local") {
				if (error.response.status === 406) {
					setIsValidBN(false);
				} else {
					appContext.setFlashError({duration:-1, messages:[<FormattedMessage id="http.networkError" values={{p: (chunks) => <p>{chunks}</p>, a: (chunks) => <a href={"https://www.cbsa-asfc.gc.ca/contact/bis-sif-"+currentLongLang()+".html"} className="App-link" target="_blank" rel="noreferrer">{chunks}</a>}}/>]});
				}
			} else {
				let salt = Math.random(); //NOSONAR -- this use of a pseudo random generator does not impact security, it's just a method to produce various IDs that won't conflict with each other
				setFieldValue("companyLegalName", messages["sima.account.accountInfo.companyLegalName.placeholder"]+salt);
				setBusinessData({
					ace_businessnumber : ace_businessnumber
					, companyOperatingName : messages["sima.account.accountInfo.companyOperatingName.placeholder"]
					, companyAddress : messages["sima.account.accountInfo.companyAddress.placeholder"]
					, companyCity : messages["sima.account.accountInfo.companyCity.placeholder"]
					, companyCountry : messages["sima.account.accountInfo.companyCountry.placeholder"]
					, companyProvince : messages["sima.account.accountInfo.companyProvince.placeholder"]
					, companyPostalZipCode : messages["sima.account.accountInfo.companyPostalZipCode.placeholder"]
					, Telephone1 : messages["common.phoneNumber.ex"]
				});
			}
		}).finally(() => {
			setShowSpinner(false);
		});

	}
	
	
	const handleAccountSubmit = async (values) => {
		console.log({values});
		console.log("InnerFormikRef.current.errors : ", InnerFormikRef.current.errors);
		
		const newAccountToPush = {
			ace_businessnumber     : values.ace_businessnumber
			, Name                 : values.companyLegalName
			, ace_partytype        : values.ace_partytype	//a.k.a. client role
			, clientConfirm        : values.clientConfirm
		}
		
		props.FieldArrayHelpersRef.current.push(newAccountToPush);
		
		setBusinessData({});
		props.setDisplayPopup(false);
	}

	function error406(type, prop, headerMessage, mouseEnterId, alertClassName, timerBarId) {
		
		return (<>
			<div id="global-alerts-container" className="row">
			  <section className="global-alert">
				<div id={mouseEnterId} onMouseEnter={() => {
					if(prop.duration !== -1) {				
						let msgObj=prop; 
						msgObj.duration=-1; 
						prop = msgObj;
						forceUpdate();	
					}
				}}>
				  <section className={"alert "+alertClassName}>
					<h3>
					  {headerMessage}!
					  {renderAlertClose(type, prop?.duration ?? 0)}
					</h3>
					{prop.messages.map(function(msg, index) {
						return (
							<div key={type+"Msg-"+index}>{msg}</div>
						);
					})}
				  </section>
				  <span id={timerBarId} className={"alert "+alertClassName+" alertTimerBar"} style={{width:'0%'}}></span>
				</div>
			  </section>
			</div>
			<div class="form-group col-md-12 text-left row-magic" style={{height: "1rem"}}></div>
		</>);
	}
	
	const renderAlertClose = (setFlashType, duration) => {
		if (setFlashType && duration < 0) {
			return <button type="button" className="mfp-close" id="globalAlertClose" onClick={()=>{
				// flashAlerts[setFlashType] = null; // TODO usestate?
				setIsValidBN(true);
				forceUpdate();
			}} >×
			</button>
		}
		return <></>;
	}


	return (
		<Formik
		  initialValues={{
		  	ace_businessnumber: ""
		  	, companyLegalName: ""
		  	, ace_partytype: ""
		  	, clientConfirm: []
		  }}
		  validateOnMount={true}
		  validationSchema={Yup.object({
		  	ace_businessnumber: Yup.string().required(messages["common.isRequired"]).matches(/^[0-9]{9}[R|r][M|m][0-9]{4}$/, messages["common.mustBeAValidBN"])
		  	, companyLegalName: Yup.string().required(messages["common.isRequired"])
		  	, ace_partytype: Yup.string().required(messages["common.isRequired"])
		  	, clientConfirm: Yup.array().min(1, messages["common.isRequired"])
		  })}
		  onSubmit={async (values, {resetForm}) => {await handleAccountSubmit(values); resetForm();}}
		>
		  {(innerFormik) => {
		  	InnerFormikRef.current = innerFormik;
		  	return (
		  		<Form>
		  		  <MagnifiquePopup 
		  		    id="addClientAccount" 
		  		    trigger={props.displayPopup} 
		  		    setTrigger={props.setDisplayPopup}
		  		    continueButton={<FormattedMessage id="sima.account.accountInfo.clientCertify.confirm.button"/>}
		  		    continueAsSubmit={true}
		  		    style={{width:"95%", height:"95%", overflowY:"scroll"}}
		  		    header={<FormattedMessage id="sima.counsel.client.addClient"/>} 
		  		    body={
		  				<>
						  {
						    !isValidBN ?
						    	error406("flashError", {duration:-1, messages:[<FormattedMessage id="ace.businessNumber.doesNotExist" values={{bn: innerFormik.values.ace_businessnumber, b: chunks => <b>{chunks}</b>}} />]}, <FormattedMessage id="globalAlert.error" />, "mouse-enter-e", "alert-danger", "errorAlertTimerBar")
							:
								<></>
						  }
		  				  <Spinner show={showSpinner}/>
		  		    	  <div className="form-group col-md-12 text-left row-magic" style={{fontSize:"1.6rem"}}>
		  		    	    <TextFieldWithLabelAndOnKeyDownHandler id="ace_businessnumber" name="ace_businessnumber" required={true} placeholder={messages["sima.account.accountInfo.businessNumber.example"]} maxLength="15" label={labels["sima.representative.businessNumber.counsel"]} 
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										e.preventDefault(); // Prevent form submission
										handleBusinessSearchClick(innerFormik.values.ace_businessnumber, innerFormik.setFieldValue)
									}
								}}
							/>
		  		    	    <p>
		  		    	      <button type="button"
		  		    	        onClick={() => {handleBusinessSearchClick(innerFormik.values.ace_businessnumber, innerFormik.setFieldValue)}} 
		  		    	        className="btn btn-primary"
		  		    	      >
		  		    	        <FormattedMessage id="wet.search"/>&nbsp;<span className="glyphicon glyphicon-search"></span>
		  		    	      </button>
		  		    	    </p>
		  		    	    <TextFieldWithLabel id="companyLegalName" name="companyLegalName" required={true} readonly="readonly" label={messages["sima.account.accountInfo.companyLegalName.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyOperatingName} label={messages["sima.account.accountInfo.companyOperatingName.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyAddress} label={messages["sima.account.accountInfo.companyAddress.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyCity} label={messages["sima.account.accountInfo.companyCity.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyCountry} label={messages["sima.account.accountInfo.companyCountry.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyProvince} label={messages["sima.account.accountInfo.companyProvince.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.companyPostalZipCode} label={messages["sima.account.accountInfo.companyPostalZipCode.label"]}/>
		  		    	    <ReadOnlyTextField placeholder={businessData.Telephone1} label={messages["common.phoneNumber"]}/>
		  		    	    
		  		    	    <SelectFieldWithLabel id="ace_partytype" name="ace_partytype" required={true} label={messages["sima.client.role"]}
		  		    	      options={[
		  		    	      	{value:null, label: messages["common.select..."]}
		  		    	      	, ...clientRolesList
		  		    	      ]}
		  		    	    />
							<CheckboxWithLabel id="clientConfirm" name="clientConfirm" required={true} 
								options={[
									{value:"yes", required:true, label: labels["sima.account.accountInfo.clientCertify.radio"]}
								]}
							/>
		  		    	    <div className="form-group col-md-12">
		  		    	      <aside>
		  		    	        <h3><FormattedMessage id="sima.document.footnote" /></h3>
		  		    	        <dl>
		  		    	          <dt><a href="#fn1-rf">[1]</a> <FormattedMessage id="sima.counsel.client.header.2" /></dt>
		  		    	          <dd id="fn1">
		  		    	            <p><FormattedMessage id="sima.account.accountInfo.businessNumber.description.footnote" /></p>
		  		    	          </dd>
		  		    	        </dl>
		  		    	      </aside>
		  		    	    </div>
		  		    	  </div>
		  		    	</>
		  		    }
		  		  />
		  		</Form>
		  	);
		  }}
		</Formik>
	);
}
const ReadOnlyTextField = ({label, ...props}) => {
	return (
		<div style={{float:"left", width:"100%"}} className="form-group col-md-12">
		  <label htmlFor={props.id || props.name} className={"control-label col-md-3"+(props.required ? " required" : "")}>
		    {label} {props.required ? <strong className="required"><FormattedMessage id="common.required.inBrackets"/></strong> : <></>}
		  </label>
		  <div className="col-md-4">
		    <input type="text" disabled="disabled" placeholder={props.placeholder} value={props.value} className={"form-control full-width"}/>
		  </div>
		</div>
	);
};


export default AddClientFormik;